<template>
  <div>
    <el-row type="flex"
            class="row-bg"
            justify="space-between">
      <blockList :list="contentList"
                 :labelPosition='"label-left"'
                 class="row-bg leftHeader"></blockList>
      <el-checkbox v-model="checked"
                   class="row-bg widthHeader">仅看服务期内</el-checkbox>
    </el-row>
    <el-col :span="24"
            class="google-list">
      <data-list style="margin-top: 10px;"
                 :page="page"
                 :table-style="{ name: 'mixture' }"
                 :data="data"
                 :columns="columns"
                 :loading="loading"
                 @page-size-changed="pageSizeChanged"
                 @page-changed="pageChanged"
                 @sort-change="sortChange"></data-list>
    </el-col>
  </div>
</template>

<script>
import customer from '@/mixins/customer';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import blockList from '@/backend/pages/googleAds/components/blockList.vue';
import adsApi from '@/backend/services/googleAds/googleAds.js'
import dayjs from 'dayjs'
const page = listPageCreate({
  searchConfig: {
    api: api.googleAds.industryUserList,
    method: 'POST',
  },
  getQuery (obj, _this) {
    obj.sortField = obj.sortName;
    obj.industryId = _this.$route.query.industryId
    delete obj.sortName;
    return _.assign(obj, {
      serverWithIn: _this.checked
    });
  }
});
export default {
  name: 'industryPackageDetails',
  components: {
    blockList,
  },
  mixins: [customer, page],
  watch: {
    checked: {
      handler () {
        this.query()
      },
      immediate: true,
    }
  },
  data () {
    let _this = this;
    return {
      contentList: {},
      checked: false,
      columns: [
        {
          label: '客户/外贸二级行业',
          bind: 'customerName',
          align: 'left',
          width: 200,
          type: 'custInfo',
          text: [
            {
              label: '',
              bind: 'customerName',
              custValue (val) {
                return val.customerName
              },
            },
            {
              label: '',
              bind: 'mainBusiness',
              custValue (val) {
                return `(${val.secondaryForeignIndustry || '无'})`
              },
              style: {
                "color": "#ccc"
              }
            }
          ],
        },
        {
          label: '服务单',
          //width: 250,
          bind: 'serviceCode',
          align: 'left',
          type: 'custInfo',
          text: [
            {
              label: '',
              bind: 'serviceCode',
              custValue (val) {
                return val.serviceCode
              },
            },
            {
              label: '',
              bind: 'serviceStatus',
              custValue (val) {
                return `(${val.serviceStatus})`
              },
              style: {
                "color": "#ccc"
              }
            }
          ]
        },
        {
          label: 'CID',
          bind: 'cid',
          align: 'left',
          type: 'percentage',
          style: {
            textAlign: 'left',
          },
          dataStyle (val) {
            return val || '-';
          },
        },
        {
          label: '获取资格时间',
          width: 150,
          bind: 'crmAuthGetTime',
          align: 'left',
          type: 'percentage',
          sort: 1,
          style: {
            textAlign: 'left',
          },
          options: [
            {
              label: '由低到高',
              value: 1,
            },
            {
              label: '由高到低',
              value: 2,
            },
          ],
        },
        {
          label: '再营销列表',
          width: 220,
          bind: 'userListName',
          align: 'left',
          type: 'custInfo',
          style: {
            textAlign: 'left',
          },
          text: [
            {
              label: '名称',
              bind: 'userListName',
            },
            {
              label: 'id',
              bind: 'userListId',
            },
            {
              label: '状态',
              custValue (val) {
                switch (val.userListStatus) {
                  case "1":
                    return '未知';
                  case "2":
                    return '开放';
                  case "3":
                    return '关闭';
                  case "4":
                    return '未明确';
                  default:
                    return '-';
                }
              },
            }
          ],
        },
        {
          label: '搜索网络规模',
          bind: 'searchNetworkScale',
          align: 'left',
          type: 'percentage',
          sort: 2,
          style: {
            textAlign: 'left',
          },
          dataStyle (val) {
            return val;
          },
          options: [
            {
              label: '由低到高',
              value: 1,
            },
            {
              label: '由高到低',
              value: 2,
            },
          ],
        },
        {
          label: '展示网络规模',
          bind: 'demonstrateNetworkScale',
          align: 'left',
          type: 'percentage',
          sort: 3,
          style: {
            textAlign: 'left',
          },
          dataStyle (val) {
            return val;
          },
          options: [
            {
              label: '由低到高',
              value: 1,
            },
            {
              label: '由高到低',
              value: 2,
            },
          ],
        },
        {
          label: '未上传邮箱数',
          bind: 'newMailboxSizeTotal',
          align: 'left',
          type: 'percentage',
          style: {
            textAlign: 'left',
          },
          dataStyle (val) {
            return val;
          },
        },
        {
          label: '操作',
          type: 'btnClick',
          align: 'left',
          style: 'text',
          width: 150,
          bind (row) {
            let { newMailboxSizeTotal, userListStatus, cid, crmAuthGetTime, serviceStatus, expirationTime } = row
            let dateXsdate = _this.dateXsdate(expirationTime)
            if (newMailboxSizeTotal > 0 && userListStatus == '2' && cid && crmAuthGetTime && dateXsdate) {
              return [
                {
                  text: '数据同步Ads',
                  trigger (row) {
                    _this.dataSynchronizationPrompt(row)
                  },
                },
              ];
            }
            return []

          },
        },
      ],
    };
  },
  methods: {
    requestData () {
      this.query();
      this.getContentList();
    },
    dateXsdate (expirationTime) {
      let expiryDate = dayjs(expirationTime).format('YYYY-MM-DD-HH-mm-ss');
      //空值
      if (expirationTime === null) return false
      let today = new Date();
      let today_time = dayjs(today).format('YYYY-MM-DD-HH-mm-ss');
      if (today_time < expiryDate) {
        //未过期
        return true
      } else {
        //过期
        return false
      }
    },
    async dataSynchronizationPrompt (row) {
      let control = await this.$confirmShow(`${row.newMailboxSizeTotal}个邮箱将填充到，${row.userListName}，是否确定同步?`, '数据同步到Ads')
      if (control) {
        let res = await adsApi.postAds({ serviceSiteId: row.serviceId });
        if (res) {
          this.$message.success(`数据同步成功`);
          this.query();
        }
      }
    },
    async getContentList () {
      let { industryId } = this.$route.query
      let res = await adsApi.getContentList({ industryId: industryId });
      let { industryName, industryEmailCount } = res.data
      this.contentList = {
        row0: [{ label: '行业包', value: industryName }, { label: '邮箱规模', value: industryEmailCount }],
      }
    }
  },
  mounted () {
    this.requestData();
  },
};
</script>

<style scoped lang="scss">
.tishi {
	font-size: 16px;
}
::v-deep .block {
	padding-bottom: 0;
}
.leftHeader {
	width: 400px;
}
.widthHeader {
	width: 159px;
}
</style>
